"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint max-lines: 0 */
/* eslint max-len: 0 */
var react_1 = __importDefault(require("react"));
var NavAudienceWorkflow = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "nav-audience-workflows" },
            react_1.default.createElement("path", { d: "M20.488 3.50266C24.1471 7.16397 25.0169 12.746 22.7674 17.3076L20.6679 17.4276C23.1873 13.4361 22.5875 8.12423 19.2283 4.76302C16.4391 1.97213 12.2999 1.07176 8.67078 2.33221C8.10086 2.51224 7.56109 2.78228 7.02111 3.08248L7.981 4.52294L2.67218 4.85307L5.04152 0.0814126L6.03129 1.58195C6.54114 1.28176 7.08115 1.01169 7.6508 0.801724C12.0299 -0.878824 17.0986 0.111316 20.4878 3.50258L20.488 3.50266ZM12.0299 24C13.4997 24 14.9692 23.73 16.349 23.1897C16.8888 22.9795 17.4287 22.7094 17.9685 22.4094L18.9583 23.91L21.3276 19.1383L16.019 19.4984L16.9789 20.9388C16.4391 21.239 15.8992 21.5091 15.3292 21.6891C11.7 22.9496 7.56104 22.0492 4.77169 19.2583C1.41253 15.8971 0.812505 10.6152 3.33208 6.59376L1.23262 6.71371C-1.01686 11.2754 -0.147165 16.8573 3.51204 20.5187C5.82155 22.7996 8.91078 24 12.0301 24L12.0299 24Z" }),
            react_1.default.createElement("path", { d: "M14.4559 7.49913C14.4559 8.87926 13.3377 9.99807 11.9584 9.99807C10.5791 9.99807 9.46094 8.87926 9.46094 7.49913C9.46094 6.119 10.5791 5.0002 11.9584 5.0002C13.3377 5.0002 14.4559 6.119 14.4559 7.49913" }),
            react_1.default.createElement("path", { d: "M11.9585 17.2319C9.22007 17.2319 6.81024 16.7496 7.0074 15.544C7.53322 12.3874 9.17629 10.5461 11.9585 10.5461C14.7408 10.5461 16.3838 12.4094 16.9096 15.544C17.1069 16.7498 14.697 17.2319 11.9585 17.2319Z" }))));
};
exports.default = NavAudienceWorkflow;
